/** Feature flags catalog — single source of truth, synced to the `features` table. */
export const FEATURES = {
  whatsapp: { description: 'Canal de WhatsApp para clientes', defaultEnabled: true },
  driver_pwa: { description: 'Aplicación web/PWA de conductores', defaultEnabled: true },
  customer_web: { description: 'Portal web de clientes', defaultEnabled: false },
  voice: { description: 'Voz en tiempo real admin <-> conductor', defaultEnabled: false },
  ptt: { description: 'Radio pulsar-para-hablar (walkie-talkie) central <-> conductores', defaultEnabled: false },
  loyalty: { description: 'Programa de fidelización', defaultEnabled: true },
  advanced_dispatch: { description: 'Estrategias de despacho avanzadas (score, prioridad, zonas)', defaultEnabled: false },
  corporate_accounts: { description: 'Cuentas corporativas', defaultEnabled: false },
  analytics: { description: 'Analítica avanzada', defaultEnabled: false },
  mobile_app: { description: 'Aplicación móvil nativa', defaultEnabled: false },
  driver_quotas: { description: 'Control de cuotas de conductores', defaultEnabled: true },
} as const;

export type FeatureKey = keyof typeof FEATURES;
export const FEATURE_KEYS = Object.keys(FEATURES) as FeatureKey[];

/** Announced but not built yet: shown as "Próximamente" and cannot be turned on. */
export const COMING_SOON_FEATURES: ReadonlySet<FeatureKey> = new Set<FeatureKey>(['customer_web', 'corporate_accounts', 'analytics', 'mobile_app']);

export function resolveFeatures(overrides: Partial<Record<string, boolean>>): Record<FeatureKey, boolean> {
  const out = {} as Record<FeatureKey, boolean>;
  for (const key of FEATURE_KEYS) out[key] = !COMING_SOON_FEATURES.has(key) && (overrides[key] ?? FEATURES[key].defaultEnabled);
  return out;
}
